if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.media = this.querySelectorAll('.product-media-modal__media');
        this.thumbs = this.querySelectorAll('.product-media-modal__thumb');
        this.thumbsSwiperEl = this.querySelector('.product-media-modal__thumbs');
        this.navPrev = this.querySelector('.product-media-modal__nav--prev');
        this.navNext = this.querySelector('.product-media-modal__nav--next');
        this.activeId = null;
        this.thumbsSwiper = null;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.setActiveMedia(thumb.dataset.mediaId));
        });
        if (this.navPrev) this.navPrev.addEventListener('click', () => this.step(-1));
        if (this.navNext) this.navNext.addEventListener('click', () => this.step(1));
        this.addEventListener('keyup', (event) => {
          if (event.code === 'ArrowLeft') this.step(-1);
          if (event.code === 'ArrowRight') this.step(1);
        });

        if (this.thumbsSwiperEl && typeof Swiper !== 'undefined') {
          const spaceBetween =
            parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--scale-200')) || 8;

          this.thumbsSwiper = new Swiper(this.thumbsSwiperEl, {
            slidesPerView: 'auto',
            spaceBetween,
            freeMode: true,
            watchSlidesProgress: true,
            centerInsufficientSlides: true,
          });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.setActiveMedia(this.openedBy.getAttribute('data-media-id'));
      }

      step(direction) {
        const ids = [...this.media].map((element) => element.dataset.mediaId);
        const currentIndex = ids.indexOf(this.activeId);
        const nextIndex = (currentIndex + direction + ids.length) % ids.length;
        this.setActiveMedia(ids[nextIndex]);
      }

      setActiveMedia(mediaId) {
        this.activeId = mediaId;

        this.media.forEach((element) => {
          element.classList.toggle('is-active', element.dataset.mediaId === mediaId);
        });

        let activeThumbIndex = -1;
        this.thumbs.forEach((element, index) => {
          const isActive = element.dataset.mediaId === mediaId;
          element.classList.toggle('is-active', isActive);
          if (isActive) activeThumbIndex = index;
        });

        if (this.thumbsSwiper && activeThumbIndex > -1) {
          this.thumbsSwiper.slideTo(activeThumbIndex);
        } else {
          const activeThumb = this.querySelector('.product-media-modal__thumb.is-active');
          if (activeThumb) activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }

        const activeMedia = this.querySelector(`.product-media-modal__media[data-media-id="${mediaId}"]`);
        const deferredMedia = activeMedia ? activeMedia.querySelector('deferred-media') : null;
        const deferredContent = deferredMedia ? deferredMedia.querySelector('template').content : null;
        if (deferredContent && deferredContent.querySelector('.js-youtube')) deferredMedia.loadContent();
      }
    }
  );
}
